"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TermsAndConditions = void 0;
const react_1 = __importDefault(require("react"));
const monera_app_core_1 = require("@amzn/monera-app-core");
const metric_helper_1 = require("@amzn/monera-app-core/lib/utils/metric-helper");
const view_1 = require("../html-widget/view");
const icons_1 = require("../icons");
const themed_text_1 = require("../themed-text");
const styles_1 = require("./styles");
const TermsAndConditions = ({ text, onChange, isChecked, error, containerRef, containerProps, description }) => {
    const [configStoreState] = (0, monera_app_core_1.useConfigStore)();
    function handleChange(event) {
        const isChecked = event.target.checked;
        const methodName = 'handleChange';
        (0, metric_helper_1.meterFatals)({
            methodName,
            metricName: isChecked ? 'termsAndConditionsAccepted' : 'termsAndConditionsUnchecked',
            success: true,
            fault: false,
            requestId: configStoreState.requestId
        });
        monera_app_core_1.LOGGER.info('Terms and conditions checkbox interaction', {
            isChecked,
            requestId: configStoreState.requestId
        });
        onChange(isChecked);
    }
    return (react_1.default.createElement(styles_1.Container, Object.assign({ ref: containerRef }, containerProps),
        description && (react_1.default.createElement(themed_text_1.ThemedSpan, { color: "base", font: "base", style: { marginBottom: '8px' } }, (0, view_1.SafeHtmlParse)(description))),
        react_1.default.createElement(styles_1.Label, { error: error },
            react_1.default.createElement(styles_1.Checkbox, { checked: isChecked, type: "checkbox", onChange: handleChange }),
            react_1.default.createElement(themed_text_1.ThemedSpan, { color: "base", font: "base" }, (0, view_1.SafeHtmlParse)(text))),
        error && react_1.default.createElement(ErrorMessage, { message: error })));
};
exports.TermsAndConditions = TermsAndConditions;
const ErrorMessage = ({ message }) => {
    const [configStoreState] = (0, monera_app_core_1.useConfigStore)();
    react_1.default.useEffect(() => {
        if (message) {
            const methodName = 'ErrorMessage';
            (0, metric_helper_1.meterFatals)({
                methodName,
                metricName: 'termsAndConditionsErrorDisplayed',
                success: false,
                fault: true,
                requestId: configStoreState.requestId
            });
            monera_app_core_1.LOGGER.warn('Terms and conditions error message displayed', {
                errorMessage: message,
                requestId: configStoreState.requestId
            });
        }
    }, [message, configStoreState.requestId]);
    return (react_1.default.createElement(styles_1.ErrorMessageContainer, null,
        react_1.default.createElement(icons_1.RioAlertIcon, { alertType: "error" }),
        react_1.default.createElement(themed_text_1.ThemedSpan, { font: "base", style: { color: monera_app_core_1.Red_500 } }, message)));
};
